import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import React from "react";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";

const ItemDetails = ({
  configurationDetails,
}: {
  configurationDetails?: any;
}) => {
  if (!configurationDetails) {
    return null;
  }
  const config = configurationDetails;
  const theme = useTheme();
  const typography = useTypographyStore();
  const isObject = (val) =>
    val && typeof val === "object" && !Array.isArray(val);

  const formatObject = (obj) => {
    return Object.entries(obj)
      .map(([key, value]) => `${key}: ${value}`)
      .join(", ");
  };

  const getObjectKeys = (obj) => Object.keys(obj || {});
  return (
    <ParentContainer>
      <Container>
        {getObjectKeys(config).map((key, index, array) => {
          if (key === "Total Price") return null;

          const value = config[key];
          return (
            <React.Fragment key={index}>
              <Row key={key}>
                <Label>
                  <VDBText
                    color={theme["core-06"]}
                    type={typography["Minor-R"]}
                  >
                    {key}
                  </VDBText>
                </Label>
                <Spacer size={SpaceType.Basic} />
                <Value>
                  <VDBText
                    color={theme["core-05"]}
                    type={typography["Minor-M"]}
                  >
                    {isObject(value) ? formatObject(value) : value}
                  </VDBText>
                </Value>
              </Row>
              {index < array.length - 1 && (
                <Spacer size={SpaceType.ExtraSmall} />
              )}
            </React.Fragment>
          );
        })}
      </Container>
    </ParentContainer>
  );
};

export default ItemDetails;

const ParentContainer = styled.View`
  background-color: ${({ theme }) => theme["core-01"]};
`;
const Container = styled.View`
  padding: ${SpaceType.Basic}px;
`;

const Row = styled.View`
  flex-direction: row;
`;

const Label = styled.View`
  width: 155px;
`;

const Value = styled.View`
  flex: 1;
`;
